import "antd/dist/antd.css";
import { Form, Button, Input, Checkbox } from "antd";
import './login.css';
import axios from "axios";
import { useState } from "react";
import swal from "sweetalert";
import { login } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
const Login = (props) => {
	const [loading, setLoading] = useState(false);
	const { isLoggedIn } = useSelector((state) => state.auth);
	//const user = localStorage.getItem("user");
	const dispatch = useDispatch();
	const onFinish = async (values) => {
		setLoading(true);
		// const response = await loginUser({
		// 	username,
		// 	password
		// });
		// đây là login vào
		//setLoading(true);
		const username = values.username;
		const password = values.password;
		try {
			if (username === undefined || username === "") {
				swal("Vui lòng nhập tên đăng nhập", {
					buttons: false,
					icon: "warning",
				});
			} else if (password === undefined || password === "") {
				swal("Vui lòng nhập mật khẩu", {
					buttons: false,
					icon: "warning",
				});
			} else {
				dispatch(login({ username, password }))
					.then(() => {
						//props.history.push("/profile");
						props.history.push("/");
						//props.history.push("/home");
						setLoading(false);
					})
					.catch(() => {
						setLoading(false);
					});
			}
		} catch (err) {
			// setTimeout(() => {
			// 	if (!err.response) {
			// 		swal("Tên đăng nhập hoặc mật khẩu không chính xác!!!", {
			// 			icon: "error",
			// 		});
			// 	} else if (err.response.status === 405) {
			// 		swal("Không có phản hồi từ server !!!");
			// 	} else {
			// 		swal("Đăng nhập thất bại !!!");
			// 	}
			// 	setLoading(false);
			// }, 1000);
			setLoading(false);
		}
	};

	const onFinishFailed = errorInfo => {
		console.log('Failed:', errorInfo);
	};

	// hình random https://source.unsplash.com/random
	// isLoggedIn true chuyển đến profile
	if (isLoggedIn) {
		window.location.href = '/adminpage'
	}
	return (
		<div className="login-page">
			<div className="login-box">
				<div className="illustration-wrapper">
					<img src="https://png.pngtree.com/png-vector/20250620/ourmid/pngtree-judges-gavel-on-law-books-legal-concept-png-image_16552135.png" alt="Login" />
				</div>
				<Form
					name="login-form"
					initialValues={{ remember: true }}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
				>
					<p className="form-title">Chào mừng trở lại</p>
					<p>Đăng nhập để quản lý thông tin</p>
					<Form.Item
						name="username"
						rules={[{ required: true, message: 'Vui lòng điền tên đăng nhập!' }]}
					>
						<Input
							placeholder="Tên đăng nhập"
						/>
					</Form.Item>

					<Form.Item
						name="password"
						rules={[{ required: true, message: 'Vui lòng điền mật khẩu!' }]}
					>
						<Input.Password
							placeholder="Mật khẩu"
						/>
					</Form.Item>
					<Form.Item>
						<Button loading={loading} type="primary" htmlType="submit" className="login-form-button">
							ĐĂNG NHẬP
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	);
};
export default Login